import React, { Fragment } from 'react'

import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectTableContext from '../../../components/tables/MultiSelectTableContext'
import SegmentationsTable from './table/SegmentationsTable'
import SegmentsLoader from './_load/SegmentsLoader'

const PageContent = () => {
  return (
    <Fragment>
      <ControlBar />

      <MultiSelectTableContext>
        <SegmentsLoader uncontrolledChildren={<MultiRowsActions />}>
          <SegmentationsTable />
        </SegmentsLoader>
      </MultiSelectTableContext>
    </Fragment>
  )
}

export default PageContent
